import { render, staticRenderFns } from "./MapPostCard.vue?vue&type=template&id=a42fee58&scoped=true&"
import script from "./MapPostCard.vue?vue&type=script&lang=js&"
export * from "./MapPostCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42fee58",
  null
  
)

export default component.exports